import { Thunk } from 'ha/myredux/types';
import { Actions } from '../constants';

const translateDescription =
  ({
    listingId,
    targetLang,
  }: {
    listingId: number;
    targetLang: string;
  }): Thunk =>
  (dispatch, _, { apiV2 }) => {
    dispatch({
      type: Actions.TRANSLATE_DESCRIPTION_START,
      payload: listingId,
      error: false,
    });

    return apiV2
      .translateListingDescription({ listingId, targetLang })
      .then(({ data }) => data)
      .then(({ description }) =>
        dispatch({
          type: Actions.TRANSLATE_DESCRIPTION_DONE,
          payload: description,
          error: false,
        }),
      )
      .catch(() =>
        dispatch({
          type: Actions.TRANSLATE_DESCRIPTION_FAIL,
          error: true,
          payload: 'Error has occurred while translating description',
        }),
      );
  };

export { translateDescription };
